import type {AddComponentTypeOptions, ComponentDefinition} from 'grapesjs';
import {FORM_CONFIRMATION_FORM_STYLES, FORM_CONFIRMATION_HEADING_TEXT_STYLES} from '@FormMakerReact/components/component-styles';
import {POSTERMYWALL_FORM_BACKGROUND_TYPE} from '@FormMakerReact/components/postermywall-form-background/postermywall-form-background';
import {POSTERMYWALL_ICON_VECTOR_TYPE} from '@FormMakerReact/components/postermywall-icon-vector/postermywall-icon-vector';
import {POSTERMYWALL_HEADING_TEXT_TYPE} from '@FormMakerReact/components/postermywall-heading-text/postermywall-heading-text';
import {POSTERMYWALL_FORM_TEXT_TYPE} from '@FormMakerReact/components/postermywall-form-text/postermywall-form-text';

export const POSTERMYWALL_CONFIRMATION_FORM_TYPE = 'postermywall-confirmation-form';
const CONFIRMATION_CONTAINER_ID = 'postermywall-confirmation-container';
const DATA_ATTR = 'data-is-pmw-confirmation-form';

export function buildDefaultConfirmationFormChildren(): ComponentDefinition[] {
  return [
    {
      type: POSTERMYWALL_FORM_BACKGROUND_TYPE,
      components: [
        {type: POSTERMYWALL_ICON_VECTOR_TYPE},
        {type: POSTERMYWALL_HEADING_TEXT_TYPE, content: window.i18next.t('pmwjs_form_maker_confirmation_default_heading'), style: FORM_CONFIRMATION_HEADING_TEXT_STYLES},
        {type: POSTERMYWALL_FORM_TEXT_TYPE, content: window.i18next.t('pmwjs_form_maker_confirmation_default_message')},
      ],
    },
  ];
}

export const POSTERMYWALL_CONFIRMATION_FORM: AddComponentTypeOptions = {
  isComponent: (el: HTMLElement) => {
    if (typeof el.getAttribute !== 'function') {
      return undefined;
    }
    return el.tagName === 'DIV' && el.getAttribute(DATA_ATTR) !== null ? {type: POSTERMYWALL_CONFIRMATION_FORM_TYPE} : undefined;
  },
  model: {
    defaults: {
      tagName: 'div',
      toolbar: [],
      copyable: false,
      draggable: false,
      droppable: false,
      hoverable: false,
      selectable: false,
      highlightable: false,
      badgable: false,
      style: FORM_CONFIRMATION_FORM_STYLES,
      attributes: {
        [DATA_ATTR]: '1',
        id: CONFIRMATION_CONTAINER_ID,
      },
    },
  },
};
